export const PLOTLY_LAYOUT_BASE = {
  paper_bgcolor: 'rgba(0,0,0,0)' as const,
  plot_bgcolor: 'rgba(0,0,0,0)' as const,
  margin: { t: 30, b: 60, l: 60, r: 20 },
  font: { family: 'Inter, system-ui, sans-serif', size: 12 },
  autosize: true,
};

const PALETTE = [
  '#2563EB', '#7C3AED', '#DB2777', '#DC2626', '#EA580C',
  '#CA8A04', '#16A34A', '#0D9488', '#0891B2', '#4F46E5',
];

export function colorForIndex(idx: number): string {
  return PALETTE[idx % PALETTE.length];
}

export function formatRating(value: number | null | undefined): string {
  if (value === null || value === undefined || Number.isNaN(value)) return 'n/a';
  return value.toFixed(2);
}

export function truncate(text: string | null | undefined, n = 40): string {
  if (!text) return '';
  return text.length > n ? text.slice(0, n - 1) + '\u2026' : text;
}

// --- time window selector ---------------------------------------------------

export type TimeWindowKey = 'all' | '3m' | '1m' | '2w' | '1w';

export const TIME_WINDOW_OPTIONS: { key: TimeWindowKey; label: string }[] = [
  { key: 'all', label: 'All time' },
  { key: '3m', label: '3 months' },
  { key: '1m', label: '1 month' },
  { key: '2w', label: '2 weeks' },
  { key: '1w', label: '1 week' },
];

export const DEFAULT_TIME_WINDOW: TimeWindowKey = 'all';

const WINDOW_DAYS: Record<Exclude<TimeWindowKey, 'all'>, number> = {
  '3m': 90,
  '1m': 30,
  '2w': 14,
  '1w': 7,
};

/**
 * Returns the cutoff timestamp for a window relative to the snapshot's
 * generation date (so "1 week ago" stays anchored to the snapshot rather
 * than to the user's clock when the report is being viewed days later).
 * `null` means "no filter".
 */
export function cutoffForWindow(
  generatedAt: Date | string | null | undefined,
  key: TimeWindowKey,
): Date | null {
  if (key === 'all') return null;
  const anchor = generatedAt
    ? generatedAt instanceof Date
      ? generatedAt
      : new Date(generatedAt)
    : new Date();
  const days = WINDOW_DAYS[key];
  return new Date(anchor.getTime() - days * 24 * 3600 * 1000);
}

export function filterByCreatedAt<T extends { created_at?: string | null }>(
  rows: T[],
  cutoff: Date | null,
): T[] {
  if (!cutoff) return rows;
  const cutoffMs = cutoff.getTime();
  return rows.filter(r => {
    if (!r.created_at) return false;
    const ts = Date.parse(r.created_at);
    return Number.isFinite(ts) && ts >= cutoffMs;
  });
}
